require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-lorem-ipsum-dolor-situm.json") })
        }
      }, "path---blog-lorem-ipsum-dolor-situm");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-lorem-ipsum-dolor-situm!./.cache/json/blog-lorem-ipsum-dolor-situm.json
// module id = 445
// module chunks = 231608221292675